// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_format from "rescript/lib/es6/caml_format.js";
import * as Config$LiveRoom from "../../../Config.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "../PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as SterlingModal$LiveRoom from "../../bindings/SterlingModal.bs.js";
import * as Button from "@sothebys/sterling/button";
import * as Tokens from "@sothebys/sterling/tokens";
import * as AnalyticsManager$LiveRoom from "../../analytics/AnalyticsManager.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

function WelcomeToAuctionroomModal(props) {
  var closeModal = props.closeModal;
  var fragment = props.fragment;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement(SterlingModal$LiveRoom.Modal.make, {
              children: null,
              className: Curry._1(Css.style, {
                    hd: CommonStyles$LiveRoom.mediaV2(/* MobileAndTablet */3, {
                          hd: Css.important(Css.maxWidth(Css.px(666))),
                          tl: /* [] */0
                        }),
                    tl: /* [] */0
                  }),
              headerClassName: Curry._1(Css.style, {
                    hd: Css.marginRight(Css.px(8)),
                    tl: /* [] */0
                  }),
              onClose: (function (param) {
                  Curry._1(closeModal, undefined);
                }),
              isOpen: true,
              headerTitle: Curry._1(t, "Common_auctionRoomLoginPrompHeader")
            }, React.createElement(SterlingModal$LiveRoom.Content.make, {
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph16Regular.make, {
                        children: Curry._1(t, "AuctionRoomProp_promptDiscription")
                      })
                }), React.createElement(SterlingModal$LiveRoom.Footer.make, {
                  children: null
                }, React.createElement(Button.Button, {
                      onClick: (function (param) {
                          Curry._1(closeModal, undefined);
                        }),
                      className: Curry._1(Css.style, {
                            hd: Css.fontWeight({
                                  NAME: "num",
                                  VAL: Caml_format.int_of_string(Tokens.Typography.bentonSansWeightMedium)
                                }),
                            tl: /* [] */0
                          }),
                      buttonStyle: "secondary",
                      children: Curry._1(t, "AuctionRoomProp_promptWatch")
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "signInButton"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(Button.Button, {
                            onClick: (function (_event) {
                                AnalyticsManager$LiveRoom.auctionRoomEntered(fragment.auctionId, fragment.title, fragment.sapSaleNumber, "Bidder");
                                AuthTokenHook$LiveRoom.triggerTransactionalUpgrade({
                                      showVerifyAccount: true,
                                      origin: /* SaleRegistration */1,
                                      saleNumber: fragment.sapSaleNumber
                                    }, undefined, Config$LiveRoom.values.transactionlUrl);
                              }),
                            className: Curry._1(Css.style, {
                                  hd: Css.important(Css.maxWidth(Css.px(144))),
                                  tl: {
                                    hd: Css.marginLeft(Css.px(20)),
                                    tl: {
                                      hd: Css.fontWeight({
                                            NAME: "num",
                                            VAL: Caml_format.int_of_string(Tokens.Typography.bentonSansWeightMedium)
                                          }),
                                      tl: /* [] */0
                                    }
                                  }
                                }),
                            children: Curry._1(t, "AuctionRoomProp_signIn")
                          })
                    })));
}

var make = WelcomeToAuctionroomModal;

export {
  make ,
}
/* Css Not a pure module */
